<template>
  <div>
    <div style="height: calc(100vh - 140px); overflow: auto;padding: 10px">
      <el-form ref="formDataRef" label-position="top" :model="formData">
        <el-card style="margin-bottom: 10px;">
          <!-- 基本信息 -->
          <el-divider>
            <div style="font-weight: bold;font-size: 16px">{{ $t('collectionCenter.basicInformation') }}</div>
          </el-divider>
          <el-row :gutter="10">
            <el-col :span="8">
              <!-- 保险公司名称 -->
              <el-form-item
                :label="$t('mdfeTranslate.InsuranceCompanyName')"
                prop="name"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change'] }
                ]"
                class="maxlengthInput"
              >
                <el-input
                  v-model="formData.name"
                  :placeholder="$t('collectionCenter.pleaseInput')"
                  show-word-limit
                  style="width: 100%;"
                  :maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="CNPJ"
                prop="cnpj"
                :rules="[
                  { required: true, validator: checkcnpj, trigger: ['blur','change'] }
                ]"
              >
                <el-input
                  v-model="formData.cnpj"
                  :placeholder="$t('collectionCenter.pleaseInput')"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card style="margin-bottom: 10px;">
          <!--配置信息-->
          <el-divider>
            <div style="font-weight: bold;font-size: 16px">{{ $t('mdfeTranslate.ConfigurationInformation') }}</div>
          </el-divider>
          <el-row :gutter="10">
            <el-col :span="8">
              <!-- 配置名称 -->
              <el-form-item
                :label="$t('mdfeTranslate.ConfigurationName')"
                prop="configName"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change'] }
                ]"
                class="maxlengthInput"
              >
                <el-input
                  v-model="formData.configName"
                  :placeholder="$t('collectionCenter.pleaseInput')"
                  style="width: 100%;"
                  show-word-limit
                  :maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-card>
            <el-row v-for="(item, index) in formData.policyNumberList" :key="index" :gutter="10">
              <el-col :span="8">
                <!-- 保单类型 -->
                <el-form-item
                  :label="$t('mdfeTranslate.PolicyType')"
                  :prop="'policyNumberList.' + index + '.type'"
                  :rules="[{ required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}]"
                >
                  <el-select v-model="item.type" style="width: 100%">
                    <el-option
                      v-for="list in policyTypeOptions"
                      :key="list.value"
                      :label="list.label"
                      :value="list.value"
                      :disabled="isOptionDisabled(list.value, index)"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 保单号 -->
                <el-form-item
                  :label="$t('mdfeTranslate.PolicyNumber')"
                  :prop="'policyNumberList.' + index + '.number'"
                  :rules="[{ required: true, validator: noChinese, trigger: ['blur','change']}]"
                  class="maxlengthInput"
                >
                  <el-input
                    v-model="item.number"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    show-word-limit
                    :maxlength="100"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="formData.policyNumberList.length > 1" :span="8">
                <el-form-item>
                  <el-button
                    type="danger" size="small" style="margin-top: 28px"
                    @click="deletePolicy(index)"
                  >{{ $t('basicData.Delete') }}</el-button><!-- 删除按钮 -->
                </el-form-item>
              </el-col>
            </el-row>
            <!--添加-->
            <el-button type="primary" size="small" @click="addPolicy">{{ $t('basicData.Add') }}</el-button>
          </el-card>
        </el-card>
        <el-card style="margin-bottom: 10px;">
          <!-- 高级设置 -->
          <el-divider>
            <div style="font-weight: bold;font-size: 16px">{{ $t('mdfeTranslate.AdvancedSettings') }}</div>
          </el-divider>
          <el-row :gutter="10">
            <el-col v-if="editType === 2" :span="8">
              <!--是否启用-->
              <el-form-item
                :label="$t('collectionCenter.ifUse')"
                prop="state"
                :rules="[{ required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change']}]"
              >
                <el-switch
                  v-model="formData.state"
                  active-color="#ff4949"
                  inactive-color="#13ce66"
                  :active-text="$t('GlobalSetObj.disable')"
                  :inactive-text="$t('collectionCenter.enable')"
                  :active-value="0"
                  :inactive-value="1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 生效时间 -->
              <el-form-item
                :label="$t('customerManagements.genterTiem')"
                prop="effectiveTime"
              >
                <el-date-picker
                  v-model="formData.effectiveTime"
                  type="datetime"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 备注 -->
              <el-form-item :label="$t('collectionCenter.Note')" class="maxlengthInput">
                <el-input
                  v-model="formData.remark" type="textarea" :rows="6"
                  :placeholder="$t('collectionCenter.pleaseInput')"
                  show-word-limit
                  :maxlength="500"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>
    <div style="text-align: right; padding: 20px;border: 1px solid #ccc;">
      <el-button size="small" @click="cancelConfiguration(1)">{{ $t('collectionCenter.cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirmConfiguration">{{ $t('collectionCenter.submit') }}</el-button>
    </div>
  </div>
</template>
<script>
import { addInsuranceService, insuranceServiceUpdateCheck, insuranceServiceUpdateConfirm } from '@/api/invoiceCenter';
export default {
  name: 'AddEdit',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editType: {
      type: Number,
      default: 1
    }
  },
  data() {
    const noChinese = (rule, value, callback) => {
      const chineseRegex = /[\u4e00-\u9fa5]/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (value && chineseRegex.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.NoChineseAllowed')));
        } else {
          callback();
        }
      }
    };
    // cnpj
    const checkcnpj = (rule, value, callback) => {
      const cnpjRegex = /^[a-zA-Z0-9]{9,12}\d{2}$/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!cnpjRegex.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.enter11Digits14'))); // 输入11位或14位数字
        } else {
          callback();
        }
      }
    };
    // 大于等于0的数字
    const checkNumber = (rule, value, callback) => {
      const regex = /^\d+$/;
      if (!value) {
        return callback();
      } else {
        if (!regex.test(value)) {
          return callback(new Error(this.$t('basicData.MustPositiveIntegerGreaterThanOrEqual0'))); // 必须是大于或等于0的正整数
        } else {
          callback();
        }
      }
    };
    return {
      formData: null,
      policyTypeOptions: [
        {
          value: 1,
          label: this.$t('mdfeTranslate.Accident') // 事故
        },
        {
          value: 2,
          label: this.$t('mdfeTranslate.TheftOfGoods') // '货物盗窃'
        }
      ],
      checkcnpj,
      checkNumber,
      noChinese
    };
  },
  created() {
    this.formData = JSON.parse(JSON.stringify(this.rowData));
  },
  methods: {
    // 检查选项是否应该被禁用
    isOptionDisabled(optionValue, currentIndex) {
      // 遍历所有保单项，检查该选项值是否已经被其他项选择
      return this.formData.policyNumberList.some((policy, index) => {
        // 排除当前正在编辑的项
        return index !== currentIndex && policy.type === optionValue;
      });
    },
    // 添加保单
    addPolicy() {
      this.formData.policyNumberList.push({
        type: '',
        number: ''
      });
    },
    // 删除保单
    deletePolicy(index) {
      this.formData.policyNumberList.splice(index, 1);
    },
    // 取消保存
    cancelConfiguration(type) {
      this.$emit('closeWindow', type);
    },
    // 提交保存
    confirmConfiguration() {
      this.$refs.formDataRef.validate(valid => {
        if (valid) {
          const obj = JSON.parse(JSON.stringify(this.formData));
          if (this.editType === 1) {
            addInsuranceService(obj).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.cancelConfiguration(2);
              }
            });
          } else {
            insuranceServiceUpdateCheck(obj).then(res => {
              if (res.code === 200) {
                if (res.msg) {
                  this.$confirm(res.msg, this.$t('GlobalSetObj.tips'), {
                    confirmButtonText: this.$t('GlobalSetObj.confirm'),
                    cancelButtonText: this.$t('GlobalSetObj.cancel'),
                    type: 'warning'
                  }).then(() => {
                    if (res.data === 1) {
                      insuranceServiceUpdateConfirm(obj).then(res => {
                        if (res.code === 200) {
                          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                          this.cancelConfiguration(2);
                        }
                      });
                    } else {
                      this.editType = 1;
                      this.formData = {
                        id: '',
                        cnpj: '',
                        name: '',
                        configName: '',
                        state: 0,
                        effectiveTime: '',
                        remark: '',
                        policyNumberList: [
                          { number: '', type: '' }
                        ]
                      };
                      this.$refs.formDataRef.clearValidate();
                    }
                  });
                } else {
                  this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  this.cancelConfiguration(2);
                }
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style>
.maxlengthInput .el-input__inner,
.maxlengthInput .el-textarea__inner {
  padding-right: 60px;
}
</style>
